/* eslint-disable jsx-a11y/control-has-associated-label */
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp, FaTimesCircle } from 'react-icons/fa';
import {
  getMyAccount, getMyAccounts, getTheme, useTopSongs,
} from '../api/queries';
import { themeVariables } from '../helpers/helpers';
import RecordingForm from '../screens/authenticated/dashboard/songs/RecordingForm';
import SongDetails from '../screens/authenticated/dashboard/songs/SongDetails';
import SongsCreateUpdate from '../screens/authenticated/dashboard/songs/songsCreateUpdate';
// import SongsCreateUpdate from '../screens/authenticated/dashboard/songs/songsCreateUpdate';
import AppState from '../store/appstate';
import ButtonPrimaryText from './buttonPrimaryText';
import ChooseAccountModal from './ChooseAccountModal';
import LoadingSmall from './loadingSmall';
import Table from './table';

const TopSongs = () => {
  const { t } = useTranslation('dashboard');
  const myAccounts = getMyAccounts();
  const topSongs = useTopSongs({ accounts: myAccounts?.data?.artistaccounts });
  const selectedAccount = AppState.useState((s) => s.selectedAccount);

  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });
  const { highlightColour } = themeVariables(theme);

  const [recordingModal, setRecordingModal] = useState(null);
  const [editModal, setEditModal] = useState(null);
  const [accountChoiceModal, setAccountChoiceModal] = useState(false);

  const [currentAac, setAac] = useState(null);
  const columns = React.useMemo(
    () => [
      {
        Header: t('dashboard:ra-column-title'),
        accessor: 'title',
        width: '25%',
        id: 'colTopSongTitle',
      },
      {
        Header: t('dashboard:ra-column-artist-account'),
        accessor: 'accountname',
        width: '25%',
        id: 'colTopSongAccount',
      },
      {
        Header: t('dashboard:ra-column-date-added'),
        accessor: 'createddate',
        width: '15%',
        id: 'colTopSongCreated',
        Cell: ({ row }) => (
          ((row?.values?.colTopSongCreated && row?.values?.colTopSongCreated !== '0000-00-00') ? format(Date.parse(row.values.colTopSongCreated), 'yyyy/MM/dd') : null)
        ),
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        width: '5%',

        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span>
            {row.isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        ),
        // We can override the cell renderer with a SubCell to be used with an expanded row
        SubCell: () => null, // No expander on an expanded row
      },
    ],
  );

  return (
    <>
      {!!accountChoiceModal
        && (
        <ChooseAccountModal
          title={t('dashboard:choose-account-songs-modal-header')}
          to="/songs/create"
          setAccountChoiceModal={setAccountChoiceModal}
          accounts={myAccounts?.data?.artistaccounts}
          nonAdminTo="/songs/"
        />
        )}
      {recordingModal !== null && (
      <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
        <div className="rounded-lg bg-white h-modal relative w-11/12 lg:w-auto">
          <button
            type="button"
            onClick={() => setRecordingModal(null)}
            className="absolute z-50 right-0 top-0 p-5 text-2xl"
          >
            <FaTimesCircle />
          </button>
          <div className="overflow-y-scroll h-modal p-4 lg:p-8">
            <RecordingForm aac={currentAac} id={recordingModal} modal closeModal={() => setRecordingModal(null)} />
          </div>
        </div>
      </div>
      )}
      {editModal !== null && (
      <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
        <div className="rounded-lg bg-white h-modal relative w-11/12 lg:w-auto">
          <button
            type="button"
            onClick={() => setEditModal(null)}
            className="absolute z-50 right-0 top-0 p-5 text-2xl"
          >
            <FaTimesCircle />
          </button>
          <div className="overflow-y-scroll h-modal p-4 lg:p-8">
            <SongsCreateUpdate
              aac={currentAac}
              id={editModal}
              modal
              closeModal={() => setEditModal(null)}
            />
          </div>
        </div>
      </div>
      )}
      <div className="w-full p-8 bg-white rounded-lg">
        <div className="flex flex-row justify-between items-center mb-8">
          <h2 className="text-another-gray font-semibold text-xl">{t('dashboard:recently-added-songs-header')}</h2>
          <ButtonPrimaryText id="btnTopSongAddSong" onClick={() => { setAccountChoiceModal(true); }}>
            {t('dashboard:add-new-song-link')}
          </ButtonPrimaryText>
        </div>
        {topSongs.isLoading
        && <LoadingSmall />}
        {topSongs.isSuccess
        && (
        <div>
          <Table
            area="TopSongs"
            data={topSongs.data}
            min={5}
            columns={columns}
            highlightColour={highlightColour}
            revealComponent={
              <SongDetails setAac={setAac} setRecordingModal={setRecordingModal} setEditModal={setEditModal} />
            }
            searchSuffix={t('common:songs-search-suffix')}
            bgClass="bg-white rounded-lg p-0"
            initialSort={[{
              id: 'createddate',
              desc: true,
            }]}
          />
        </div>
        )}
        {topSongs.isError
        && (
        <div>
          <p>{t('dashboard:recent-songs-error')}</p>
        </div>
        )}
      </div>
    </>
  );
};

export default TopSongs;
